import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem('bj_admin_user');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (adminData, token) => {
    localStorage.setItem('bj_admin_token', token);
    localStorage.setItem('bj_admin_user', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.removeItem('bj_admin_token');
    localStorage.removeItem('bj_admin_user');
    setAdmin(null);
  };

  function isSuperAdmin() {
    return admin && admin.role === 'superadmin';
  }

  return <AdminContext.Provider value={{ admin, login, logout, isSuperAdmin }}>{children}</AdminContext.Provider>;
}

export const useAdmin = () => useContext(AdminContext);
